import { render, staticRenderFns } from "./CellularUsageInfo.vue?vue&type=template&id=57461042&"
import script from "./CellularUsageInfo.vue?vue&type=script&lang=js&"
export * from "./CellularUsageInfo.vue?vue&type=script&lang=js&"
import style0 from "./CellularUsageInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57461042')) {
      api.createRecord('57461042', component.options)
    } else {
      api.reload('57461042', component.options)
    }
    module.hot.accept("./CellularUsageInfo.vue?vue&type=template&id=57461042&", function () {
      api.rerender('57461042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Profile/CellularUsageInfo.vue"
export default component.exports